// Service Worker registration (P9.0). Production + HTTPS (or localhost) only — never in dev/preview.
import { toast } from "sonner";

const isLocalhost = ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname);

export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  const isProd = process.env.NODE_ENV === "production";
  const isSecure = window.location.protocol === "https:" || isLocalhost;
  if (!isProd || !isSecure) return; // SW only on deployed HTTPS build / localhost

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      reg.onupdatefound = () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.onstatechange = () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) {
            toast("A new version is ready.", {
              action: { label: "Refresh", onClick: () => { sw.postMessage("SKIP_WAITING"); window.location.reload(); } },
              duration: 10000,
            });
          }
        };
      };
    }).catch(() => {});
  });
}

// Request a Background Sync flush of the offline sale queue (best-effort).
export async function requestQueueFlushSync() {
  try {
    const reg = await navigator.serviceWorker?.ready;
    if (reg && "sync" in reg) await reg.sync.register("pos-queue-flush");
  } catch (_) {}
}
